import { render } from "./DietSelector.vue?vue&type=template&id=13c53dca&scoped=true"
import script from "./DietSelector.vue?vue&type=script&lang=js"
export * from "./DietSelector.vue?vue&type=script&lang=js"

import "./DietSelector.vue?vue&type=style&index=0&id=13c53dca&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c53dca"]])

export default __exports__